// extracted by mini-css-extract-plugin
module.exports = {"control":"TextareaWithLabel__control--1EbQM","error":"TextareaWithLabel__error--By2XP"};